import React from "react";

import Footer from "../Footer";
import { NewNavbar } from "../Pages/NewNavbar";
import sellerBannerImg from "../../../assets/image/seller-guide-center-image.png";
import guideLion from "../../../assets/image/lion-watercolor.png";
import WhatYouGainSection from "../Components/UI/WhatYouGainSection";
import claim from "../../../assets/image/claim.png";

import gift from "../../../assets/image/gift.gif";
import Guide from "../buy/Guide";

export default function SellerGuide() {
  const infoCards = [
    {
      desc: "Discover how Milford Real Estate is defining the home-selling experience with a client-first approach that puts your goals at the center.",
      icon: "/icon3/icon1.png",
    },
    {
      desc: "Learn how our expert-led process, local knowledge, and innovative strategies are designed to make your sale smooth, strategic, and stress-free.",
      icon: "/icon3/icon2.png",
    },
    {
      desc: "Gain confidence from working with dedicated Realtors® who know your neighborhood and are committed to delivering exceptional results.",
      icon: "/icon3/icon3.png",
    },
    {
      desc: "Partner with a team that goes beyond the transaction, offering personalized guidance, trusted support, and a streamlined path to success.",
      icon: "/icon3/icon4.png",
    },
  ];
  return (
    <>
      <NewNavbar buySellActive={false} />
      {/* Seller Guide banner section start */}
      <section className="seller-guide-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="center-img text-center col-md-10">
              <img src={sellerBannerImg} alt="" className="img-fluid" />
              <div className="img-content-wrap">
                <h1>Hello!</h1>
                <p>
                  Ready to sell with confidence? Your
                  <b> Milford Seller Guide </b> is designed to walk you through
                  every stage of the home-selling process with clarity,
                  strategy, and expert support — tailored to your unique goals.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Seller Guide banner section end */}
      <WhatYouGainSection
        bookSrc={claim}
        bottomSection={false}
        infoCard={infoCards}
        title={"What To Expect From Our Seller Guide:"}
        subtitle={"SMART SELLING. ELEVATED."}
        topIcon={gift}
        customClass={"col-md-6 col-xl-3"}
      />
      <div className="bookFrame" style={{ height: "100vh", width: "100%" }}>
        <iframe
          src="https://d3ms8mre5rhtvu.cloudfront.net?hash=QkQ4OUFBQkJEQzkrdmM1Njg4OGNqbA=="
          width="100%"
          height="100%"
          scrolling="no"
          frameBorder="0"
          allowFullScreen
          allow="autoplay; clipboard-read; clipboard-write"
        ></iframe>
      </div>
      <Guide mode="2" />
      <Footer />
    </>
  );
}
